module.exports = __webpack_public_path__ + "static/media/icon-thumb.38d49bcc.png";